import { CustomerOptionalItem } from '../../../enums/customerOptionalItem'
import { CustomerNumber } from '../elements/CustomerNumber'
import { InvoicingLanguageAndCurrency } from '../elements/InvoicingLanguageAndCurrency'
import { PaymentTerm } from '../elements/PaymentTerm'

export const getOptionalItems = () => {
  return {
    [CustomerOptionalItem.CustomerNumber]: <CustomerNumber />,
    [CustomerOptionalItem.LanguageAndCurrency]: <InvoicingLanguageAndCurrency />,
    [CustomerOptionalItem.PaymentTerm]: <PaymentTerm />,
  }
}
